module.exports = __webpack_public_path__ + "img/1衛武營.f34c4757.jpg";